import { apiRequest } from "../../../../shared/lib/api";

export type AchievementType =
  | "athlete"
  | "organizer"
  | "event"
  | "ranking"
  | "participation";

export type AchievementStatus = "locked" | "unlocked";
export type AchievementRarity = "common" | "rare";

export type Achievement = {
  id: string;
  name: string;
  description: string;
  icon: string;
  type: AchievementType;
  criterion: Record<string, unknown>;
  rarity: AchievementRarity;
  status: AchievementStatus;
  unlockedAt: string | null;
};

export async function listMyAchievements(token: string) {
  const response = await apiRequest<{ achievements: Achievement[] }>(
    "/api/me/achievements",
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.achievements || [];
}
